module.exports = __webpack_public_path__ + "img/icon3D.377b9df2.svg";